import {
    request,
    requestPublic
} from './request.js'
// 报考指南
// 获取列表
export function getEntryGuideList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/EntryGuide/GetEntryGuideList',
        method: 'get',
        params: {
            Category: obj.category,
            Title: obj.title,
            pageIndex: obj.pageIndex,
            pageSize: obj.pageSize,
        }
    })
}
// 获取详情
export function getEntryGuideDetail(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/EntryGuide/GetEntryGuideDetail',
        method: 'get',
        params: {
            Id: id
        }
    })
}

// 添加
export function createEntryGuide(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/EntryGuide/CreateEntryGuide',
        method: 'post',
        data: data
    })
}
// 编辑
export function updateEntryGuide(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/EntryGuide/UpdateEntryGuide',
        method: 'post',
        data: data
    })
}

// 删除
export function delEntryGuide(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/EntryGuide/DelEntryGuide',
        method: 'post',
        params: {
            Id: id
        }
    })
}